/**
 * Priority enum where the lowest number has the highest priority
 */
export enum PRIORITY {
  HIGH = 1,
  MEDIUM = 3,
  LOW = 7,
}

export enum LOYALTY_STATUS {
  NONE = 5,
  FEATURED = 1,
  NEW = 2,
  // Stock availability statuses,
  STOCK_LOW = 3,
  LIMITED_STOCK = 4,

  // Disabled statuses
  COMING_SOON = 7,
  NOT_ENOUGH_POINTS = 8,
  LIMIT_REACHED = 9,
  SOLD_OUT = 10,
  LOCKED = 11,
}
